<template>
    <v-card width="330">
        <v-container>
            <v-row>
                <v-col cols="0" class="d-flex flex-column justify-space-between text-start">
                    <h2>{{ companySettings.CompanyName.value }}</h2>
                    <div>
                        {{ companySettings.AddressStreet.value }}, <br>
                        {{ companySettings.AddressZipAndCity.value }}
                    </div>
                    <div>
                        {{ companySettings.Telephone.value }}<br>
                        {{ companySettings.Email.value }} <!--<br>
                        www.primulator.no-->
                    </div>
                </v-col>
                <v-col cols="auto" align="center">
                    <Qr :url="qrLink" :size="100" />
                    <h4 class="pt-2">{{ qrText }}</h4>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import Qr from "@/components/SingleUse/Qr.vue";

export default {
    name: 'QrLabelCard',
    props: {
        companySettings: {
            type: Object,
            required: true,
        },
        qrLink: String,
        qrText: String,
    },
    components: {
        Qr,
    },
    mixins: [clientAPI],

    data() {
        return {};
    },

    mounted() {
    },

    methods: {},

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>